export default "__VITE_ASSET__D7bTF7c2__"